import {utils} from 'ethers';
import {computed, makeAutoObservable, observable} from 'mobx';
import {tokenDecimals} from '../helpers/config/contracts.config';

export const convertNrsBalanceToDecimal = (balance: string) => {
    return Number(utils.formatUnits(balance, tokenDecimals.nrs)) + '';
}

class StakeBalanceStore {
    latestUpdateAt = 0;
    nrsTokenBalance = '0';
    nrsAvailableBalance = '0';

    get nrsAvailableBalanceDecimal() {
        return convertNrsBalanceToDecimal(this.nrsAvailableBalance);
    }
    get nrsTokenBalanceDecimal() {
        return convertNrsBalanceToDecimal(this.nrsTokenBalance);
    }

    constructor() {
        makeAutoObservable(this, {
            nrsAvailableBalance: observable,
            nrsTokenBalance: observable,
            nrsAvailableBalanceDecimal: computed,
            nrsTokenBalanceDecimal: computed,
        });
    }

    public setNrsAvailableBalance(newBalance: string) {
        this.nrsAvailableBalance = newBalance;
    }

    public resetState() {
        this.nrsTokenBalance = '0';
        this.nrsAvailableBalance = '0';
    }

    setNrsTokenBalanceDecimal(newBalance: string) {
        this.nrsTokenBalance = newBalance;
    }

    async fetchBalances(nrsContract: any, veNrsContract: any, address: string) {
        this.latestUpdateAt = Date.now()
        {
            const balance = await nrsContract.read.balanceOf([address]);
            this.setNrsTokenBalanceDecimal(balance.toString());
        }
        {
            const balance = await veNrsContract.read.maxWithdraw([address]);
            this.setNrsAvailableBalance(balance.toString());
        }
    }

    async fetchBalancesThrottled(nrsContract: any, veNrsContract: any, address: string) {
        if (this.latestUpdateAt === 0 || Date.now() - this.latestUpdateAt > 5000) {
            await this.fetchBalances(nrsContract, veNrsContract, address)
        }
    }

}

export const stakeBalanceStore = new StakeBalanceStore();
